import { render, staticRenderFns } from "./TravelPostMap.vue?vue&type=template&id=37216336&"
import script from "./TravelPostMap.vue?vue&type=script&lang=js&"
export * from "./TravelPostMap.vue?vue&type=script&lang=js&"
import style0 from "./TravelPostMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelPostMap.vue"
export default component.exports